import checkIsPriceShownInQuery from './checkIsPriceShownInQuery';

/**
 * Whether a price should be hidden from the checkout picker.
 *
 * Mirrors `isFieldHidden` for form fields: a `hidden` price is removed from the
 * picker, but revealed when the URL query lists the price's `reference` in
 * `show_prices` (e.g. `?show_prices=prc_ab12cd,prc_ef34gh`) — the same
 * convention as `show_fields` / `show_variants` / `show_tickets`. `enabled: false`
 * (Disable) is handled separately and is never revealable.
 *
 * The per-price overrides (`${reference}_price`, `_label`, `_preselected`, …) do
 * NOT reveal: they act on prices the buyer can already select, so a hidden price
 * needs `show_prices` alongside them.
 */
export default function isPriceHidden(price = {}, query = {}) {
  if (!price.hidden) return false;
  return !checkIsPriceShownInQuery(price.reference, query);
}
